import { useNavigate, useParams } from 'react-router-dom';
import classNames from 'classnames';
import navConfig from './navConfig.json';

function ProfileNav() {
  const navigate = useNavigate();
  const { slug_2 } = useParams();

  return (
    <div className="flex justify-center mt-0 gap-2">
      {navConfig.map(item => (
        <div
          key={item.slug_2}
          className={`text-xs lg:text-base rounded-md border-2 cursor-pointer px-2 py-1 ${classNames({
            "border-blue-600": slug_2 === item.slug_2,
          })}`}
          onClick={() => navigate(item.path)}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
}

export default ProfileNav;
